var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SharedButton', {
    attrs: {
      "variant": "".concat(_vm.buttonStyle),
      "disabled": _vm.disableButton
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm.iconClass !== '' ? _c('i', {
    class: "mr-1 mdi ".concat(_vm.iconClass)
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.buttonText) + " ")]);
}
var staticRenderFns = []

export { render, staticRenderFns }